$('document').ready(() => {
    const params = document.querySelector('.product-param');

    if (!params) return;

    const HIDE_ITEM_COUNT = 9;
    const btn = params.querySelector('.product-param__show');
    const children = Array.from(params.children);

    let isHide = false;

    hideElements();

    btn.addEventListener('click', () => {
        if (isHide) {
            showElements();
        } else {
            hideElements();
        }
    })

    function hideElements() {
        let count = 0;

        children.forEach(item => {
            if (item.tagName === 'p') {
                if (count >= HIDE_ITEM_COUNT) {
                    item.classList.add('hide');
                }
            } else {
                let hideCount = 0;

                Array.from(item.children).forEach(li => {
                    if (count >= HIDE_ITEM_COUNT) {
                        li.classList.add('hide');

                        hideCount++;
                    }

                    count++;
                })

                if (item.children.length > 0 && hideCount === item.children.length) {
                    item.classList.add('hide');
                    item.previousElementSibling.classList.add('hide');
                    count--;
                }
            }

            count++;
        })

        if (count >= HIDE_ITEM_COUNT) {
            isHide = true;
            btn.classList.add('active');
            params.classList.remove('opened');
        }
    }

    function showElements() {
        isHide = false;
        params.querySelectorAll('.hide').forEach(param => {
            if (!param.classList.contains('js-product-card-info-content')) {
                param.classList.remove('hide');

            }
        });
        params.classList.add('opened');
    }


//     let tabsCaption = $('.tabs__caption');
//     let tabsCaptionActiveClass = 'tabs__caption-item--active';
//     let tabsContentActiveClass = 'tabs__content-item--active';
//
//     tabsCaption.click((e) => {
//         if ($(e.target).hasClass('tabs__caption-item')) {
//             $(e.target)
//                 .addClass(tabsCaptionActiveClass)
//                 .siblings()
//                 .removeClass(tabsCaptionActiveClass)
//             $(e.target)
//                 .parents('.tabs')
//                 .find(`.tabs__content-item`)
//                 .removeClass(tabsContentActiveClass)
//                 .eq($(e.target).index())
//                 .addClass(tabsContentActiveClass)
//         }
//     })
});
